import {useToast} from "@hooks";
import {useCallback} from "react";
import {postSubmit} from "@ui-seeker/utils";
import {BACKEND_APIS, REPORT_STATUS} from "@constants";
import { setBatchData} from "../@signals";

export default function useBatchMultiple(selectedData, setSelectedRows){
    const { showToast } = useToast()
    const  msg = selectedData.length > 1
        ? `these ${selectedData.length} Batches`
        : 'the selected batch'

    const handleStopMultipleExecutions = useCallback(() => {
        showToast.confirm(`Are you sure to stop ${msg}?`, {
            onSubmit: () => {
                selectedData.map(({id_batch}) => setBatchData({id_batch, status: REPORT_STATUS.STOPPED}))
                showToast.promise(postSubmit(`${BACKEND_APIS.INTERMEDIARY}/check/executions/batch/force`, {
                    idBatch: selectedData.map(a => a.id_batch)
                }).finally(() => {
                    setSelectedRows([])
                }))
            }
        })
    }, [JSON.stringify(selectedData)])

    return {
        handleStopMultipleExecutions
    }
}